<template>
  <span class="selected-filters">
    <span v-if="title" class="selected-filters__title" v-text="title" />
    <span class="selected-filters__items">
      <FiltersList
        v-if="limitedList"
        :filters="limitedList"
        v-on="$listeners"
      />
    </span>
    <BasicButton
      v-if="buttonVisible"
      appearance="pseudo-link"
      @click="showAll = true"
    >
      Показать все
    </BasicButton>
  </span>
</template>

<script>
  import BasicButton from "src/components/BasicButton/BasicButton.vue";
  import FiltersList from "src/components/filters/FiltersList/FiltersList.vue";

  export default {
    name: 'SelectedFilters',
    components: { BasicButton, FiltersList },
    props: {
      items: {
        type: Array,
        required: true,
      },
      title: String,
      max: Number,
    },
    data() {
      return {
        showAll: false,
      }
    },
    computed: {
      buttonVisible() {
        if (this.showAll) return false;
        return this.items.length > this.max;
      },
      limitedList() {
        const { items, max, showAll } = this;
        if (showAll || !max) return items;
        return items.slice(0, max);
      },
    },
  }
</script>